import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import AuthSessionGate from './AuthSessionGate';

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

/**
 * Wraps routes that require authentication. Redirects to /login when not authenticated.
 * Use with <Outlet /> for nested routes, or pass children for a single element.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  return (
    <AuthSessionGate>
      {isAuthenticated ? (
        (children ?? <Outlet />)
      ) : (
        <Navigate to="/login" replace state={{ from: location.pathname }} />
      )}
    </AuthSessionGate>
  );
};

export default ProtectedRoute;
